export const USER_SETTINGS = 'user_settings';
export const LOCAL_USER_DATA = 'user_data';
export const REMEMBER_ME_DATA = 'remember_me_data';
export const DEVELOPER_PORTAL_EULA_NAME = 'emdevportal';
